<div *ngIf="this.systemService.deviceInfo?.platform !== 'web'"
     class="h-100">
    <div class="page-wrapper welcome tab-only-padd-container tab-only-space-even app-welcome">
        <div class="img-wrapper d-flex flex-column align-items-center justify-content-center">
            <img class="mt-5 mb-2"
                 src="assets/images/welcome.svg"
                 alt="welcome-banner" />
            <ion-text class="heading text-center">Welcome to one stop solution for your investments </ion-text>
        </div>
        <div class="action-btn mb-5">
            <div class="w-100">
                <bh-button theme="dark"
                           (click)="navigate(routes.loginarn, '')">CONTINUE TO LOGIN</bh-button>
            </div>
            <div class="w-100 text-center mt-2">
                <bh-button theme="light"
                           (click)="goToEmpanelment('empanelment')">GET EMPANELLED</bh-button>
                <!-- <ion-text class="cursor-pointer font-18" color="primary" (click)="goToEmpanelment('empanelment')">Get Empanelled</ion-text> -->
            </div>
        </div>
    </div>
</div>

<div *ngIf="this.systemService.deviceInfo?.platform === 'web'"
     class="override-margin-landing">
    <div id="landing"
         class="page-content-container d-block d-lg-block position-relative h-100">
        <ul class="sticky-landing-nav no-list-style">
            <li (click)="spy.scrollTo('one')"
                [attr.data-focused]="spy?.active === 'one' && showSticky"
                class="mb-3">
                <ion-icon class="font-18"
                          src="assets/icon/tabs/transaction.svg"
                          alt="transaction"></ion-icon>
            </li>
            <li (click)="spy.scrollTo('two')"
                [attr.data-focused]="spy?.active === 'two'"
                class="mb-3">
                <ion-icon class="font-18"
                          src="assets/icon/tabs/opportunities.svg"
                          alt="opportunities"></ion-icon>
            </li>
            <li (click)="spy.scrollTo('three')"
                [attr.data-focused]="spy?.active === 'three'"
                class="mb-3">
                <ion-icon class="font-18"
                          src="assets/icon/tabs/prostart.svg"
                          alt="prostart"></ion-icon>
            </li>
            <li (click)="spy.scrollTo('four')"
                [attr.data-focused]="spy?.active === 'four'"
                class="mb-3">
                <ion-icon class="font-18"
                          src="assets/icon/tabs/cobranding.svg"
                          alt="cobranding"></ion-icon>
            </li>
            <li (click)="spy.scrollTo('five')"
                [attr.data-focused]="spy?.active === 'five'">
                <ion-icon class="font-18"
                          src="assets/icon/tabs/statements.svg"
                          alt="statements"></ion-icon>
            </li>
        </ul>

        <header class="bh-desktop-header bg-white py-3 d-lg-none full-width-dk-container px-3 mob-landing-header">
            <div class="d-flex align-items-center justify-content-between">
                <ion-img class="cursor-pointer"
                         src="assets/images/kotak-logo.svg"
                         alt="logo"
                         (click)="navigate('/')"></ion-img>

                <div class="d-flex align-items-center">
                    <div class="me-2">
                        <ion-text color="primary"
                                  (click)="goToEmpanelment('empanelment')">Get Empanelled</ion-text>
                    </div>

                    <div class="w-8rem">
                        <bh-button theme="dark"
                                   (click)="navigate(routes.loginarn, '')">LOGIN</bh-button>
                    </div>
                </div>
            </div>
        </header>

        <div class="welcome-other-content position-relative full-width-dk-container w-100 bg-white"
             id="scroll-landing"
             ngbScrollSpy
             #spy="ngbScrollSpy"
             [ngStyle]="{'height.px': viewHeight === 0 ? 'auto' : viewHeight}"
             style="overflow-x: hidden !important">
            <div class="position-relative welcome-page landing-full-height landing-page-hero welcome-other-content">
                <ion-img class="welcome-overlay d-none d-lg-block"
                         width="500"
                         height="500"
                         src="assets/images/bh-watermark.svg"
                         alt="watermark"></ion-img>
                <div class="welcome-page-wrapper h-100 w-100">
                    <div class="landing-container row no-negative-margin welcome-page h-100 d-flex align-items-center justify-content-between">
                        <div class="px-0 col-12 col-md-12 col-lg-5 landing-container-content">
                            <div class="">
                                <ion-text color="primary"
                                          class="text-center text-lg-start weight-700 register-dt-leading primary-color d-block">Business Hub</ion-text>
                                <ion-text class="text-center text-lg-start weight-600 register-dt-sub d-block mb-2 mt-3"
                                          color="primary">Helps in
                                    <ion-text *ngIf="currentSlide === 1"
                                              class="from-bottom"
                                              color="secondary">finding business opportunities</ion-text>
                                    <ion-text *ngIf="currentSlide === 2"
                                              class="from-bottom"
                                              color="secondary">building your brand</ion-text>
                                    <ion-text *ngIf="currentSlide === 3"
                                              class="from-bottom"
                                              color="secondary">your quest for continuous learning</ion-text>
                                    <ion-text *ngIf="currentSlide === 4"
                                              class="from-bottom"
                                              color="secondary">simplifying your daily operational work</ion-text>
                                </ion-text>
                            </div>
                            <div class="d-flex align-items-start justify-content-between justify-content-md-start mt-4 flex-wrap flex-md-nowrap">
                                <div class="max-width-mobile-only me-md-3"
                                     *ngFor="let count of listpageData?.countFilterList; let countIndex=index;">
                                    <img class="count-icon"
                                         height="25"
                                         width="25"
                                         [src]="count.logoPath | safe: 'resourceUrl'"
                                         alt="user" />
                                    <ion-text class="d-block weight-600 font-32"
                                              color="secondary">{{count.count | viewCountFormat}}</ion-text>
                                    <ion-text class="d-block weight-400 font-16 font-gray"
                                              color="medium">{{count.header}}</ion-text>
                                </div>
                            </div>
                        </div>
                        <div class="px-0 col-12 col-md-12 col-lg-7 landing-container-image py-lg-0 mt-lg-5">
                            <div class="animation-container">
                                <ion-img class="background"
                                         src="assets/images/landing-page/animation/animation-background.svg"
                                         alt="background"></ion-img>

                                <div class="changing-images">
                                    <ion-img [attr.data-focused]="currentSlide === 1"
                                             class="sl-img image-1 position1"
                                             src="assets/images/landing-page/animation/business-opportunities.svg"
                                             alt="business opportunities"></ion-img>
                                    <ion-img [attr.data-focused]="currentSlide === 2"
                                             class="sl-img image-2 position2"
                                             src="assets/images/landing-page/animation/building-brand.svg"
                                             alt="building brand"></ion-img>
                                    <ion-img [attr.data-focused]="currentSlide === 3"
                                             class="sl-img image-3 position3"
                                             src="assets/images/landing-page/animation/continuous-learning.svg"
                                             alt="continuous learning"></ion-img>
                                    <ion-img [attr.data-focused]="currentSlide === 4"
                                             class="sl-img image-4 position4"
                                             src="assets/images/landing-page/animation/simplifying-work.svg"
                                             alt="simplifying work"></ion-img>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="one"
                 class="welcome-page-wrapper boxheight welcome-page-section">
                <div class="landing-initiate-transaction landing-section-padding">
                    <!-- <div class="to-next-section"> -->
                    <div class="to-next-section d-none d-md-block d-lg-block">
                        <ion-img src="assets/images/landing-page/to-journey.svg"
                                 alt="next"></ion-img>
                    </div>

                    <ion-text ngbScrollSpyFragment="one"
                              class="text-uppercase text-center d-block font-20 weight-600 pt-4"
                              color="secondary">Initiate Transaction</ion-text>
                    <ion-text class="text-center d-block weight-700 section-title pb-2">Start your journey Now!</ion-text>

                    <div class="mt-4 row no-negative-margin align-items-center">
                        <div class="col-12 col-md-6 col-lg-6 px-0 position-relative pe-md-5">
                            <ion-img class="w-75 py-2 py-md-0 py-lg-0"
                                     src="assets/images/dashboard/initiate-transaction.svg"
                                     alt="journey"></ion-img>
                            <ion-img class="line-to-next d-none d-md-block"
                                     src="assets/images/landing-page/journey-line.svg"
                                     alt="line"></ion-img>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 px-0">
                            <ion-text class="d-block weight-400 font-18 py-2 text-center text-md-start text-lg-start">Help your clients to start small or expand their portfolio today with confidence. You can initiate transaction for existing or new customers on our portal.</ion-text>
                            <div class="mt-3 mt-md-5 landing-init-btn">
                                <bh-button theme="dark"
                                           (click)="navigate(routes.loginarn, routes.initiateTransaction)">INITIATE TRANSACTION</bh-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="two"
                 ngbScrollSpyFragment="two"
                 class="welcome-page-wrapper boxheight welcome-page-section">
                <div class="landing-opportunities landing-section-padding add-grey-bg">
                    <div class="verticle-dot-line"></div>
                    <div class="row no-negative-margin align-items-center">
                        <div class="col-12 col-md-6 col-lg-6 px-0">
                            <ion-text class="text-uppercase font-20 weight-600 pt-4 d-block text-center text-md-start text-lg-start"
                                      color="secondary">The Opportunities</ion-text>
                            <ion-text class="weight-700 section-title pb-2">Grab these opportunities Today!</ion-text>
                            <ion-img class="w-100 d-block d-md-none d-lg-none my-4"
                                     src="assets/images/landing-page/opportunities.svg"
                                     alt="opportunities"></ion-img>
                            <ion-text class="d-block weight-400 font-18 pb-2 mt-3 text-center text-md-start text-lg-start">Stay ahead of the game with our in-depth analytical reports on mutual fund opportunities. Make informed decisions to grow your business and reach your financial goals.</ion-text>
                            <div class="mt-2 mt-md-5 mt-lg-5 landing-init-btn">
                                <bh-button theme="dark"
                                           (click)="navigate(routes.loginarn, routes.oppotunity)">EXPLORE NOW</bh-button>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 px-0 img-cont position-relative">
                            <ion-img class="w-75 d-none d-md-block d-lg-block"
                                     src="assets/images/landing-page/opportunities.svg"
                                     alt="opportunities"></ion-img>
                            <ion-img class="line-to-next d-none d-md-block d-lg-block"
                                     src="assets/images/landing-page/opportunities-line.svg"
                                     alt="line"></ion-img>
                        </div>
                    </div>
                </div>
            </div>
            <div id="three"
                 ngbScrollSpyFragment="three"
                 class="welcome-page-wrapper boxheight welcome-page-section position-relative">
                <div class="prostart landing-section-padding add-blue-bg">
                    <div class="row no-negative-margin align-items-center">
                        <ion-text class="text-uppercase font-24 weight-600 pb-4 text-white text-center text-md-start text-lg-start d-block d-md-none">PROSTART</ion-text>
                        <div class="col-12 col-md-7 col-lg-7 px-0 img-cont d-flex pe-md-4">
                            <ion-img class="prostart-img-lg"
                                     src="assets/images/landing-page/prostart.svg"
                                     alt="prostart"></ion-img>
                            <ul class="d-flex flex-column no-list-style prostart-listing-points">
                                <li class="d-flex align-items-start mb-4">
                                    <ion-icon src="assets/images/landing-page/pro-tick.svg"
                                              alt="checkmark"></ion-icon>
                                    <ion-text class="text-white font-24 weight-600">
                                        260+
                                        <ion-text class="text-white font-14 weight-500 d-block mt-2">tutorials</ion-text>
                                    </ion-text>
                                </li>
                                <li class="d-flex align-items-start mb-4">
                                    <ion-icon src="assets/images/landing-page/pro-tick.svg"
                                              alt="checkmark"></ion-icon>
                                    <ion-text class="text-white font-24 weight-600">
                                        28
                                        <ion-text class="text-white font-14 weight-500 d-block mt-2">training modules</ion-text>
                                    </ion-text>
                                </li>
                                <li class="d-flex align-items-start mb-4">
                                    <ion-icon src="assets/images/landing-page/pro-tick.svg"
                                              alt="checkmark"></ion-icon>
                                    <ion-text class="text-white font-24 weight-600">
                                        17,000+
                                        <ion-text class="text-white font-14 weight-500 d-block mt-2">trainings conducted</ion-text>
                                    </ion-text>
                                </li>
                            </ul>
                        </div>
                        <div class="col-12 col-md-5 col-lg-5 px-0 ps-lg-5">
                            <ion-text class="text-uppercase font-20 weight-600 pt-4 text-white text-center text-md-start text-lg-start d-none d-md-block">PROSTART</ion-text>
                            <ion-text class="weight-700 section-title text-white pb-2 mt-md-2">Learn Anytime, Anywhere!</ion-text>
                            <ion-text class="d-block weight-400 font-18 pb-2 mt-3 text-white text-center text-md-start text-lg-start">Empower your financial knowledge with our video learning Initiative by Kotak Mutual Fund.</ion-text>
                            <div class="mt-5 landing-init-btn white">
                                <bh-button theme="light"
                                           (click)="navigate(routes.loginarn, routes.prostartVideos)">LEARN NOW</bh-button>
                            </div>
                        </div>
                    </div>

                    <div class="mt-0 mt-md-5 mt-lg-5 pt-4">
                        <div class="videos-listing-section my-3 d-flex position-relative justify-content-start justify-content-md-center">
                            <div [ngClass]="listpageData?.filterList?.length <= 2 ? 'w-auto': ''"
                                 class="mb-4 me-md-3 me-lg-0 mb-lg-0 video-card-container"
                                 *ngFor="let video of listpageData?.filterList">
                                <div class="video-card">
                                    <div [ngClass]="!this.systemService.minimizedSideBar ? 'video-card-thumbnail two-in-row': 'video-card-thumbnail'"
                                         [ngStyle]="{
                                            'background-image': video.link ? 'url(' + getYoutubeThumbnail(video.link) + ')' : 'url(' + video.thumbnailImagePath + ')',  
                                            'background-position': 
                                            'center', 'background-repeat': 
                                            'no-repeat', 'background-size': 'cover'
                                        }"
                                         (click)="clickOnVideo(video)">
                                        <ion-img class="cursor-pointer"
                                                 src="assets/icon/pro-start/play-circle.svg"
                                                 alt="play"></ion-img>
                                        <ion-text *ngIf="video?.videoDuration"
                                                  class="video-card-time text-white weight-500">{{video.videoDuration}}</ion-text>
                                    </div>

                                    <div class="video-card-details p-3">
                                        <ion-text class="font-16 weight-600 one-line-ellipsis"
                                                  color="primary">{{video.videoName}}</ion-text>
                                        <ion-text class="font-12 weight-400 one-line-ellipsis opacity-06 my-1"
                                                  color="medium">by {{video.uploadedBy ? video.uploadedBy : video.createdBy}}</ion-text>
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex align-items-center">
                                                <ion-icon class="font-14"
                                                          src="assets/icon/pro-start/eye.svg"
                                                          alt="views"></ion-icon>
                                                <ion-text class="font-12 opacity-06 weight-400 ms-1"
                                                          color="medium">{{video.watchCount * video.multiplier | viewCountFormat}}</ion-text>
                                            </div>
                                            <div class="d-flex align-items-center ms-3 ms-md-2 ms-lg-3">
                                                <div class="dot"></div>
                                                <ion-icon class="font-14 ps-3 ps-md-2 ps-lg-3"
                                                          src="assets/icon/pro-start/like.svg"
                                                          alt="liked"></ion-icon>
                                                <ion-text class="font-12 opacity-06 weight-400 ms-1"
                                                          color="medium">{{(video.likeCount || 0 ) | viewCountFormat}} <ion-text class="font-12 opacity-06 weight-400 d-inline-block d-md-none d-lg-none d-xl-inline-block ps-1"
                                                              color="medium">likes</ion-text></ion-text>
                                            </div>
                                            <div class="d-flex align-items-center ms-3 ms-md-2 ms-lg-3">
                                                <div class="dot"></div>
                                                <ion-icon class="font-14 ps-3 ps-md-2 ps-lg-3"
                                                          src="assets/icon/pro-start/calendar.svg"
                                                          alt="date"></ion-icon>
                                                <ion-text class="font-12 opacity-06 d-inline-block d-md-none d-lg-none d-xl-inline-block weight-400 ms-1"
                                                          color="medium">{{video.startDate | date}}</ion-text>
                                                <ion-text class="font-12 opacity-06 d-none d-md-inline-block d-xl-none weight-400 ms-1"
                                                          color="medium">{{(video.startDate | date)?.split(',')[0]}}</ion-text>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ion-img class="d-none d-md-block d-lg-block line-to-next-prostart"
                         src="assets/images/landing-page/journey-line.svg"
                         alt="line"></ion-img>
                <modal-pop-up [customClass]="'pre-login-yt-modal'"
                              [modalSize]="'lg'"
                              (onTogglePopUp)="onCloseModal()"
                              *ngIf="this.listpageMeta?.properties?.showModal">
                    <ion-text class="font-20 m-0 weight-700 pe-5 py-3"
                              color="primary"></ion-text>
                    <iframe *ngIf="!this.listpageData.curruntSelectedVideo.filePath"
                            class="yt-iframe-pre-login"
                            [src]="this.listpageData.curruntSelectedVideo.link | safe: 'resourceUrl'"
                            [title]="this.listpageData.curruntSelectedVideo.videoName"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                            width="100%"
                            height="500"
                            style="border-radius: 10px"></iframe>
                    <video *ngIf="this.listpageData.curruntSelectedVideo.filePath"
                           class="yt-iframe-pre-login"
                           #videoPlayer
                           autoplay
                           controls
                           width="100%"
                           height="500"
                           style="border-radius: 10px">
                        <source [src]="this.listpageData.curruntSelectedVideo.filePath | safe: 'resourceUrl'"
                                type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </modal-pop-up>
            </div>

            <div id="four"
                 ngbScrollSpyFragment="four"
                 class="welcome-page-wrapper boxheight welcome-page-section">
                <div class="cobranding landing-section-padding add-grey-bg">
                    <div class="row no-negative-margin align-items-center">
                        <div class="col-12 col-md-5 col-lg-5 px-0">
                            <ion-text class="text-uppercase font-20 weight-600 pt-4 d-block text-center text-md-start text-lg-start"
                                      color="secondary">CO-BRANDING</ion-text>
                            <ion-text class="weight-700 section-title pb-2">Let's grow together!</ion-text>
                            <ion-img class="w-100 d-block d-md-none d-lg-none my-4"
                                     src="assets/images/landing-page/cobranding.svg"
                                     alt="opportunities"></ion-img>
                            <ion-text class="d-block weight-400 font-18 pb-2 mt-3 text-center text-md-start text-lg-start">Explore our wide selection of marketing materials, including videos, GIFs, PDFs, and images, covering product marketing, financial concept marketing, and market updates. Co-brand these resources with Kotak Mutual Fund to enhance your brand identity and elevate your
                                marketing efforts.</ion-text>
                            <div class="mt-2 mt-md-5 mt-lg-5 landing-init-btn">
                                <bh-button theme="dark"
                                           (click)="navigate(routes.loginarn, routes.coBranding)">GET STARTED</bh-button>
                            </div>
                        </div>
                        <div class="col-12 col-md-7 col-lg-7 px-0 img-cont position-relative">
                            <ion-img class="w-75 d-none d-md-block d-lg-block"
                                     src="assets/images/landing-page/cobranding.svg"
                                     alt="cobranding"></ion-img>
                            <ion-img class="line-to-next d-none d-md-block d-lg-block position-absolute"
                                     src="assets/images/landing-page/cobranding-line.svg"
                                     alt="cobranding"></ion-img>
                        </div>
                    </div>

                    <div class="position-absolute"></div>
                </div>
            </div>

            <div id="five"
                 ngbScrollSpyFragment="five"
                 class="welcome-page-wrapper boxheight welcome-page-section">
                <div class="our-services landing-section-padding">
                    <div class="row no-negative-margin align-items-center">
                        <div class="col-12 col-md-7 col-lg-7 px-0 img-cont">
                            <ion-img class="w-75 d-none d-md-block d-lg-block"
                                     src="assets/images/landing-page/services.svg"
                                     alt="cobranding"></ion-img>
                        </div>
                        <div class="col-12 col-md-5 col-lg-5 px-0">
                            <ion-text class="text-uppercase font-20 weight-600 pt-4 d-block text-center text-md-start text-lg-start"
                                      color="secondary">OUR SERVICES</ion-text>
                            <ion-text class="weight-700 section-title pb-2">Start your journey Now!</ion-text>
                            <ion-img class="w-100 d-block d-md-none d-lg-none my-4"
                                     src="assets/images/landing-page/services.svg"
                                     alt="cobranding"></ion-img>
                            <ion-text class="d-block weight-400 font-18 pb-2 mt-3 text-center text-md-start text-lg-start">Invest your time in building businesses rather than routine services. Get access to account statement, capital gain statement, transact history and manage your client’s progress effectively.
                            </ion-text>
                            <div class="mt-2 mt-md-5 mt-lg-5 landing-init-btn">
                                <bh-button theme="dark"
                                           (click)="navigate(routes.loginarn, routes.accountStatement)">GET STARTED</bh-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="listpageData?.testimonialFilterList?.length !== 0"
                 id="six"
                 ngbScrollSpyFragment="six"
                 class="welcome-page-wrapper testimonials-container welcome-page-section">
                <ion-img class="pattern-one"
                         src="assets/images/landing-page/red-dots.svg"
                         alt="pattern"></ion-img>
                <ion-img class="pattern-two"
                         src="assets/images/landing-page/dots-blue.svg"
                         alt="pattern"></ion-img>
                <div class="testimonials landing-section-padding add-grey-bg">
                    <ion-img class="mail-img"
                             src="assets/images/landing-page/paper-plane.svg"
                             alt="paper plane"></ion-img>
                    <ion-text class="text-uppercase text-center d-block font-20 weight-600 pt-4 negative-mt text-center"
                              color="secondary">Testimonial</ion-text>
                    <ion-text class="text-center d-block weight-700 section-title pb-2">Hear from our partners</ion-text>

                    <div class="d-block d-lg-block">
                        <div *ngIf="showTestimonial"
                             class="testimonial-carousel position-relative mt-5"
                             [ngClass]="listpageData?.testimonialFilterList?.length <= 3 ? 'center-testimonial-content': ''">
                            <swiper-container class="bh-swiper"
                                              navigation="true"
                                              autoplay="false"
                                              loop="true"
                                              slides-per-view="3.5">
                                <swiper-slide class="h-auto"
                                              *ngFor="let testimonial of listpageData?.testimonialFilterList">
                                    <div class="bh-card testimonial-carousel-card p-4 me-3">
                                        <div class="d-flex align-items-center">
                                            <img class="person-img"
                                                 [src]="testimonial.filePath | safe: 'resourceUrl'"
                                                 alt="profile" />
                                            <div class="ms-3">
                                                <ion-text class="d-block weight-700 text-capitalize font-18 mb-1"
                                                          color="primary">{{ testimonial.ifaName }}</ion-text>
                                                <ion-text class="d-block role weight-400 text-capitalize font-12">{{ testimonial.arnCompany }}</ion-text>
                                            </div>
                                        </div>
                                        <ion-text class="d-block message weight-400 mt-3 text-capitalize font-14">{{ testimonial.description }}</ion-text>
                                    </div>
                                </swiper-slide>
                            </swiper-container>
                        </div>
                    </div>
                    <!-- 
                    <div class="d-block d-lg-none">
                        <div class="d-flex overflow-visible min-100vw">
                            <div class="testimonial-carousel-mob mt-5">
                                <div class="testimonial-carousel-mob-card" *ngFor="let testimonial of listpageData?.testimonialFilterList">
                                    <div class="bh-card p-4 me-3">
                                        <div class="d-flex align-items-center">
                                            <img class="person-img" [src]="testimonial.filePath | safe: 'resourceUrl'" alt="profile" />
                                            <div class="ms-3">
                                                <ion-text class="d-block weight-700 text-capitalize font-18 mb-1" color="primary">{{ testimonial.ifaName }}</ion-text>
                                                <ion-text class="d-block role weight-400 text-capitalize font-12">{{ testimonial.arnCompany }}</ion-text>
                                            </div>
                                        </div>
                                        <ion-text class="d-block message weight-400 mt-3 text-capitalize font-14">{{ testimonial.description }}</ion-text>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div id="seven"
                 ngbScrollSpyFragment="seven"
                 class="welcome-page-wrapper welcome-page-section">
                <div class="on-the-go landing-section-padding d-flex align-items-center justify-content-center h-100">
                    <div class="go-content-container">
                        <div class="go-content">
                            <ion-text class="weight-700 section-title text-white pb-2">Time is Money</ion-text>
                            <ion-text class="weight-700 section-title text-white pb-2">Spend it Wisely!</ion-text>
                            <ion-text class="d-block weight-300 font-18 pb-2 mt-3 text-white text-center text-md-start text-lg-start">Download now and access your investments anytime, anywhere with ease.</ion-text>
                            <div class="mt-5 install-actions d-flex mb-3 justify-content-center justify-content-md-start">
                                <a rel="noopener"
                                   href="https://play.google.com/store/apps/details?id=kotak.mutualfund&hl=en_SG"
                                   rel="noopener"><ion-img class="me-4 cursor-pointer"
                                             src="assets/images/landing-page/Google Play.svg"
                                             alt="play store"></ion-img></a>
                                <a href="https://apps.apple.com/in/app/kotak-business-hub/id1494282988"
                                   rel="noopener"><ion-img class="cursor-pointer"
                                             src="assets/images/landing-page/App Store.svg"
                                             alt="appstore"></ion-img></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="eight"
                 ngbScrollSpyFragment="eight"
                 class="welcome-page-wrapper welcome-page-section">
                <div class="landing-register landing-section-padding add-grey-bg">
                    <div class="row no-negative-margin align-items-center">
                        <div class="col-12 col-md-7 col-lg-7 px-0 img-cont">
                            <ion-img class="w-75 mx-auto m-md-0 mx-lg-0"
                                     src="assets/images/login/login-step1.svg"
                                     alt="join"></ion-img>
                        </div>
                        <div class="col-12 col-md-5 col-lg-5 px-0">
                            <ion-text class="text-uppercase font-20 weight-600 pt-4 d-block text-center text-md-start text-lg-start"
                                      color="secondary">GET STARTED !</ion-text>
                            <ion-text class="weight-700 section-title pb-2"> Welcome to Kotak Mutual Fund!</ion-text>
                            <div class="mt-5 landing-init-btn">
                                <bh-button theme="dark"
                                           (click)="navigate('/login', '')">REGISTER</bh-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-desktop d-none d-lg-block">
                <bh-desktop-footer></bh-desktop-footer>
            </div>
        </div>
    </div>
</div>